import Flex from "../Flex";

interface ModalContentContainerProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const ModalContentContainer = ({
  children,
  footer,
}: ModalContentContainerProps) => {
  return (
    <Flex
      flexDirection={"column"}
      gap={0.5}
      flex={1}
      height={"100%"}
      p={"6px 6px 6px 6px"}
      justifyContent={"space-between"}
    >
      <Flex
        height={"calc(100% - 44px )"}
        maxHeight={"calc(100vh - 44px )"}
        p={1}
        overflow={"auto"}
        position={"relative"}
      >
        {children}
      </Flex>
      {footer && (
        <Flex
          alignItems={"center"}
          height={"44px"}
          justifyContent={"end"}
          px={1}
          borderTop={"1px solid #E0E0E0"}
        >
          {footer}
        </Flex>
      )}
    </Flex>
  );
};

export default ModalContentContainer;
